export default function initProductToggles() {
    const toggleWrappers = document.querySelectorAll(".packagesToggle");
    if (!toggleWrappers.length) return; // No product toggles on this page

    toggleWrappers.forEach(toggleWrapper => {
        const blockIndex = toggleWrapper.dataset.block;
        if (!blockIndex) return;

        const planBlock = document.querySelector(`.plan-block[data-block="${blockIndex}"]`);
        if (!planBlock) return;

        const buttons = toggleWrapper.querySelectorAll("button");
        const prices = planBlock.querySelectorAll(".package__price");

        if (!buttons.length || !prices.length) return;

        buttons.forEach(btn => {
            btn.addEventListener("click", () => {
                const mode = btn.dataset.mode;
                if (!mode) return;

                // Update active button
                buttons.forEach(b => b.classList.remove("active"));
                btn.classList.add("active");

                // Show matching prices
                prices.forEach(price => {
                    price.style.display =
                        price.dataset.priceMode === mode ? "block" : "none";
                });
            });
        });

        // Initialise default state
        if (buttons.length > 0) {
            buttons[0].click();
        }
    });
}